import { atom } from 'nanostores'

import type { PromotionData } from '@/services/promotion'

export const $promotion = atom<PromotionData | null>(null)
export const $promotionLoading = atom<boolean>(true)
